// export const API_BASE_URL = "http://localhost/web/v1/user/";
export const API_BASE_URL =
  "https://cavinkareapi.bigcityexperiences.in/v1/user/";



// WEBPACK FOOTER //
// ./src/constants.js